import { render } from "./ProjectSiteNav.vue?vue&type=template&id=9331c314&ts=true"
import script from "./ProjectSiteNav.vue?vue&type=script&lang=ts"
export * from "./ProjectSiteNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__